
import React from 'react';
import { DepartmentType, Location } from './types';

export const BRAND = {
  name: 'UnityForce',
  org: 'YMCA',
  logoUrl: 'https://oneymca.org/app/themes/one-ymca/dist/images/logos/logo-white_89b27db6.png',
  colors: {
    primary: '#000000',
    secondary: '#FFFFFF',
    accent: '#F37021',
  }
};

export const DEPARTMENTS = [
  DepartmentType.FAMILY_YOUTH,
  DepartmentType.HEALTH_WELLBEING,
  DepartmentType.HOUSING,
  DepartmentType.TRAINING_EDUCATION,
  DepartmentType.SUPPORT_ADVICE
];

const DEFAULT_HOURS = {
  open: '00:00',
  close: '23:59',
  isClosed: false
};

const WEEK_HOURS = {
  'Monday': { ...DEFAULT_HOURS },
  'Tuesday': { ...DEFAULT_HOURS },
  'Wednesday': { ...DEFAULT_HOURS },
  'Thursday': { ...DEFAULT_HOURS },
  'Friday': { ...DEFAULT_HOURS },
  'Saturday': { ...DEFAULT_HOURS },
  'Sunday': { ...DEFAULT_HOURS },
};

export const LOCATIONS: Location[] = [
  // Housing Division
  { id: 'h-hw', name: 'High Wycombe hostel', address: 'Buckinghamshire', departments: [DepartmentType.HOUSING], type: 'Housing', status: 'In Service', openingHours: WEEK_HOURS },
  { id: 'h-wel-h', name: 'Welwyn hostel', address: 'Hertfordshire', departments: [DepartmentType.HOUSING], type: 'Housing', status: 'In Service', openingHours: WEEK_HOURS },
  { id: 'h-wel-hmo', name: 'Welwyn HMOs', address: 'Hertfordshire', departments: [DepartmentType.HOUSING], type: 'Housing', status: 'In Service', openingHours: WEEK_HOURS },
  { id: 'h-ste-h', name: 'Stevenage Hostel', address: 'Hertfordshire', departments: [DepartmentType.HOUSING], type: 'Housing', status: 'In Service', openingHours: WEEK_HOURS },
  { id: 'h-she', name: 'Shenwood court hostel', address: 'Hertfordshire', departments: [DepartmentType.HOUSING], type: 'Housing', status: 'In Service', openingHours: WEEK_HOURS },
  { id: 'h-hf', name: 'Housing first houses', address: 'Regional', departments: [DepartmentType.HOUSING], type: 'Housing', status: 'In Service', openingHours: WEEK_HOURS },
  { id: 'h-cha', name: 'Charter house hostel', address: 'Hertfordshire', departments: [DepartmentType.HOUSING], type: 'Housing', status: 'In Service', openingHours: WEEK_HOURS },
  { id: 'h-and', name: 'Anderson house / SHAP', address: 'Regional', departments: [DepartmentType.HOUSING], type: 'Housing', status: 'In Service', openingHours: WEEK_HOURS },
  { id: 'h-lut', name: 'Luton HMO', address: 'Bedfordshire', departments: [DepartmentType.HOUSING], type: 'Housing', status: 'Not In Service', openingHours: WEEK_HOURS },
  { id: 'h-bed', name: 'Bedford HMO', address: 'Bedfordshire', departments: [DepartmentType.HOUSING], type: 'Housing', status: 'Not In Service', openingHours: WEEK_HOURS },

  // YP Services
  { id: 'yp-bs', name: 'Bishop Stortford Hostel', address: 'Hertfordshire', departments: [DepartmentType.FAMILY_YOUTH], type: 'YP Services', status: 'In Service', openingHours: WEEK_HOURS },
  { id: 'yp-hod', name: 'Hoddesdon HMO', address: 'Hertfordshire', departments: [DepartmentType.FAMILY_YOUTH], type: 'YP Services', status: 'In Service', openingHours: WEEK_HOURS },
  { id: 'yp-hem', name: 'Hemel Hempstead HMO', address: 'Hertfordshire', departments: [DepartmentType.FAMILY_YOUTH], type: 'YP Services', status: 'In Service', openingHours: WEEK_HOURS },
  { id: 'yp-aca', name: 'Acacia House HMOs', address: 'Hertfordshire', departments: [DepartmentType.FAMILY_YOUTH], type: 'YP Services', status: 'In Service', openingHours: WEEK_HOURS },
  { id: 'yp-ste', name: 'Stevenage HMOS', address: 'Hertfordshire', departments: [DepartmentType.FAMILY_YOUTH], type: 'YP Services', status: 'In Service', openingHours: WEEK_HOURS },
];

export const ICONS = {
  Dashboard: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={1.5} d="M3 3h7v7H3V3zM14 3h7v7h-7V3zM3 14h7v7H3v-7zM14 14h7v7h-7v-7z" />
    </svg>
  ),
  Rota: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={1.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  ),
  People: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  ),
  Leave: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  Timesheets: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  ),
  AI: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
    </svg>
  ),
  Settings: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  Locations: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  )
};
